export default __webpack_public_path__ + "media/typewriter.81a0f7dd7b4a98a6ea35da38884731d8.webp";